module.exports = __webpack_public_path__ + "img/logo.7f64eaf6.png";